import React from 'react';
import { createSvgIcon } from '@mui/material';
export default createSvgIcon(React.createElement("path", { d: " M 12, 12\n            m -0.5 -11.75\n            a 11.75 11.75 0 1 0 1 0\n            z\n            m 1 1.55\n            a 10.2 10.2 0 1 1 -1 0\n            Z" }), 'RadioButtonOff');
